import * as React from 'react';
import { $generateHtmlFromNodes } from "@lexical/html";
import { LexicalComposer } from "@lexical/react/LexicalComposer";
import { ContentEditable } from "@lexical/react/LexicalContentEditable";
import { LexicalErrorBoundary } from "@lexical/react/LexicalErrorBoundary";
import { HistoryPlugin } from "@lexical/react/LexicalHistoryPlugin";
import { OnChangePlugin } from '@lexical/react/LexicalOnChangePlugin';
import { RichTextPlugin } from "@lexical/react/LexicalRichTextPlugin";
import { TabIndentationPlugin } from '@lexical/react/LexicalTabIndentationPlugin';
import type { EditorState, LexicalEditor } from 'lexical';
import { isFunction } from '../helpers/utils';
import { editorCodeConfig } from "./editorConfigCode";
import type { EditorProps } from "./editorProps.ts";
import CodeHighlightPlugin from "./plugins/CodeHighlightPlugin";
import ToolbarCodePlugin from "./plugins/toolbarCodePlugin";
import ToolbarHistoryPlugin from "./plugins/toolbarHistoryPlugin";

type Props = EditorProps & {}

function EditorCode({
	updateState,
	updateHtml,
	config,
}: Props) {
	config = {...editorCodeConfig, ...config};

	function onChange(editorState: EditorState, editor: LexicalEditor) {
		if (updateHtml && isFunction(updateHtml)) {
			editor.update(() => {
				updateHtml($generateHtmlFromNodes(editor, null));
			});
		}
		if (updateState && isFunction(updateState)) {
			editorState.read(() => {
				updateState(editorState.toJSON());
			});
		}
	}

	return (
		<LexicalComposer initialConfig={config}>
			<div className="editor-container">
				<ToolbarHistoryPlugin/>
				<ToolbarCodePlugin/>
				<div className="editor-inner">
					<CodeHighlightPlugin/>
					<HistoryPlugin/>
					<TabIndentationPlugin/>
					<OnChangePlugin onChange={onChange} ignoreSelectionChange={true}/>

					<RichTextPlugin
						contentEditable={
							<div className="editor-scroller">
								<pre className="editor mb-0">
									<ContentEditable className="editor-input p-0" />
								</pre>
							</div>
						}
						placeholder={null}
						ErrorBoundary={LexicalErrorBoundary}
					/>

					{/*<div dangerouslySetInnerHTML={{__html: htmlString}}/>*/}
					{/*<Dump value={config}/>*/}
				</div>
			</div>
		</LexicalComposer>
	);
}

export default EditorCode;
